import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ProductDetailsPageContext } from "@insite/content-library/Pages/ProductDetailsPage";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Icon from "@insite/mobius/Icon";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries, injectCss } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { useEffect, useRef, useState } from "react";
import { css } from "styled-components";
import InfoNewIcon from "@MasterBluePrint/Icons/InfoNew";
import siteMessage from "@insite/client-framework/SiteMessage";
import { ReactSVG } from 'react-svg';

const enum fields {
    hazardousGoodIconTitle = "hazardousGoodIconTitle",
    hazardousGoodIconUrl = "hazardousGoodIconUrl",
    hazardousGoodIconSvgCode = "hazardousGoodIconSvgCode",
    hazardousGoodIconDescription = "hazardousGoodIconDescription",
    showHazardousGoodIcon = "showHazardousGoodIcon",
    shippingRestrictionIconTitle = "shippingRestrictionIconTitle",
    shippingRestrictionIconUrl = "shippingRestrictionIconUrl",
    shippingRestrictionIconSvgCode = "shippingRestrictionIconSvgCode",
    shippingRestrictionIconSvgCodeNextDayAir = "shippingRestrictionIconSvgCodeNextDayAir",
    shippingRestrictionIconDescription = "shippingRestrictionIconDescription",
    showShippingRestrictionIcon = "showShippingRestrictionIcon",
  
    dryIceIconSvgCode = "dryIceIconSvgCode",   
    dryIceIconDescription = "dryIceIconDescription",

    mustShipFreightIconSvgCode = "mustShipFreightIconSvgCode",   
    mustShipFreightIconDescription = "mustShipFreightIconDescription",

    califPropIconTitle = "califPropIconTitle",
    califPropIconUrl = "califPropIconUrl",
    califPropIconSvgCode = "califPropIconSvgCode",
    califPropIconDescription = "califPropIconDescription",
    showCalifPropIcon = "showCalifPropIcon",

    roHsIconTitle = "roHsIconTitle",
    roHsIconUrl = "roHsIconUrl",
    roHsIconSvgCode = "roHsIconSvgCode",
    roHsIconDescription = "roHsIconDescription",
    showRoHsIcon = "showRoHsIcon",

    autoLotCategoryProductIconTitle = "autoLotCategoryProductIconTitle",
    autoLotCategoryProductIconUrl = "autoLotCategoryProductIconUrl",
    autoLotCategoryProductIconSvgCode = "autoLotCategoryProductIconSvgCode",
    autoLotCategoryProductIconDescription = "autoLotCategoryProductIconDescription",
    showAutoLotCategoryProductIcon = "showAutoLotCategoryProductIcon",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.showHazardousGoodIcon]: boolean;
        [fields.hazardousGoodIconSvgCode]: string;
        [fields.hazardousGoodIconTitle]: string;
        [fields.hazardousGoodIconUrl]: string;
        [fields.hazardousGoodIconDescription]: string;

        [fields.dryIceIconSvgCode]: string;
        [fields.dryIceIconDescription]: string;

        [fields.mustShipFreightIconSvgCode]: string;
        [fields.mustShipFreightIconDescription]: string;

        [fields.shippingRestrictionIconTitle]: string;
        [fields.shippingRestrictionIconSvgCode]: string;
        [fields.shippingRestrictionIconSvgCodeNextDayAir]: string;
        [fields.shippingRestrictionIconDescription]: string;
        [fields.shippingRestrictionIconUrl]: string;
        [fields.showShippingRestrictionIcon]: boolean;

        [fields.califPropIconTitle]: string;
        [fields.califPropIconUrl]: string;
        [fields.califPropIconSvgCode]: string;
        [fields.califPropIconDescription]: string;
        [fields.showCalifPropIcon]: boolean;

        [fields.showRoHsIcon]: boolean;
        [fields.roHsIconSvgCode]: string;
        [fields.roHsIconDescription]: string;
        [fields.roHsIconTitle]: string;
        [fields.roHsIconUrl]: string;

        [fields.showAutoLotCategoryProductIcon]: boolean;
        [fields.autoLotCategoryProductIconSvgCode]: string;
        [fields.autoLotCategoryProductIconDescription]: string;
        [fields.autoLotCategoryProductIconTitle]: string;
        [fields.autoLotCategoryProductIconUrl]: string;
    };
}

type Props = OwnProps & WidgetProps & HasProduct;

export interface HazmatStyles {
    labelText?: TypographyProps;
    valueText?: TypographyProps;
    container?: GridContainerProps;
    hazmatGridItem?: GridItemProps;
    hazmatContainer?: InjectableCss;
    hazmatHalf?: InjectableCss;
    sizeTool?: InjectableCss;
    thisFont?: InjectableCss;
    tooltip?: InjectableCss;
    tooltipHeading?: InjectableCss;
    tooltipContent?: InjectableCss;
    autoLotTooltipContent?:InjectableCss;
    tooltipIcon?: InjectableCss;
    autoLotProductHandlingLabel?:TypographyProps;
}

export const hazmatStyles: HazmatStyles = {
    labelText: {
        size: 14,
        weight: "bold",
        css: css`
            margin-right: .9375rem;
        `,
    },
    valueText: {
        size: 14,
        css: css`
            margin-bottom: 0;
        `,
    },
    container: {
        gap: 10,
        css: css`
            width: 100%;
            position: relative;
        `,
    },
    hazmatGridItem: {
        width: 6,
        css: css`
            width: 50%;
            padding: .8rem;
            position: absolute;
        `,
    },
    hazmatContainer: {
        css: css`
            background: #f3f6f9;
            padding: 1rem 5px !important;
            span {
                display: flex;
            }
        `,
    },
    thisFont: {
        css: css`
        font-size: .87rem;
        display:flex;
        align-items:center;
        letter-spacing: -.0625rem;
        > span {
            margin-right: .4rem !important;            
        }
        > span div div {
            display:flex;
            align-items:center;            
        }
        `,
    },
    hazmatHalf: {
        css: css`
            flex-basis: 50%;
            white-space: nowrap;
          
        `,
    },
    sizeTool: {
        css: css`
        
        `,
    },
    autoLotProductHandlingLabel: {
        css: css`
            position: relative;
            display:flex;
            color: #002554;
            font-size: 0.9rem;
            font-weight: 900;
            -webkit-letter-spacing: -.019rem;
            -moz-letter-spacing: -.019rem;
            -ms-letter-spacing: -.019rem;
            letter-spacing: -.019rem;
            line-height: 1.438rem;
        `,
    },
    tooltipIcon: {
            css: css`
                display: inline-block;
                position: relative;
                margin-left: 5px;
                z-index: 9;
                cursor:pointer;
                
                svg {
                    width: 1.5rem;
                    height: 1.5rem;
                    scale:0.8;
                }
            `,
        },
        tooltip: {
            css: css`
                background-color: #fff;
                box-shadow: 0 7px 17px 0 rgba(0,37,84,0.23);
                position: absolute;
                width: 250px;
                padding: 1.25rem;
                display: none;
                z-index: 99;
                right: -110px;
                bottom: 39px;
                &.active {
                    display: block;
                    max-width:18rem;
                }
    
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            null,
                            css`
                                max-width: 11rem !important;
                                max-height: 18rem !important;
                                margin-right: 2rem !important;
                                padding-right: 1.9rem !important;
                            `,
                            null,
                            null,
                        ],
                        "max",
                    )}
            `,
        },
        tooltipHeading: {
            css: css`
                position: relative;
                color: #002554;
                font-family: Roboto;
                font-size: 1.125rem;
                font-weight: 500;
                letter-spacing: 0;
                line-height: 31px;
                margin-bottom: 10px;
                text-align: left;
                &:after {
                    height: 3px;
                    width: 0.665rem;;
                    background-color: #C63527;
                    content: '';
                    display: inline-block;
                    position: absolute;
                    bottom: -2px;
                    left: 1px;
                }
            `,
        },
        tooltipContent: {
            css: css`
                color: #424B5A;
                font-family: Lato;
                font-size: .9rem;
                letter-spacing: 0.17px;
                line-height: 1.35rem;
                text-align: left !important;
                font-weight: 500 !important;

                &:after {
                    content: '';
                    display: block;
                    height: 0;
                    position: absolute;
                    width: 0;
                    border: 12px solid;
                    border-color: #fff transparent transparent transparent;
                    z-index: 99;
                    bottom: -1.4375rem;
                    right: 118px;
                }

                @media screen and (min-width: 1023px) and (max-width: 1100px) {
                    &:after {
                        right: 80px !important;
                    }
                }

                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            null,
                            css`
                                &:after {
                                    right: 80px !important;
                                }
                            `,
                            css`
                                &:after {
                                    right: 100px;
                                }
                            `,
                            null,
                        ],
                        "max",
                    )}
            `,
        },             
        autoLotTooltipContent: {
            css: css`
                color: #424B5A;
                font-family: Lato;
                font-size: .9rem;
                letter-spacing: 0.17px;
                line-height: 1.35rem;
                text-align: left !important;
                font-weight: 500 !important;
                &:after {
                    content: '';
                    display: block;
                    height: 0;
                    position: absolute;
                    width: 0;
                    border: 12px solid;
                    border-color: #fff transparent transparent transparent;
                    z-index: 99;
                    bottom: -1.4375rem;
                    right: 112px;
                }
    
                @media screen and (min-width: 1023px) and (max-width: 1100px) {
                    &:after {
                        right: 80px !important;
                    }
                }
    
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            null,
                            css`
                                &:after {
                                    right: 80px !important;
                                }
                            `,
                            css`
                                &:after {
                                    right: 100px;
                                }
                            `,
                            null,
                        ],
                        "max",
                    )}
            `,
        },
};

const styles = hazmatStyles;

const ComplianceIcons: React.FC<Props> = ({ product, fields }) => {
    if (!product.productNumber) {
        return null;
    }
    const [applyIconStyle, setApplyIconStyle] = useState(false);
    const [applyIconStyleVar, setApplyIconStyleVar] = useState<InjectableCss | undefined>();
    const [showText, setShowText] = React.useState(false);
    let shippingIconText = "";
    let isShowShippingIconText = true;
    let shippingClassificationSVG = "";
    let iscaliforniaProp65="";
    let autoLotCategoryProduct="";
    let isProductDryIce = false;

    if (product.detail?.shippingClassification?.toLowerCase() === "mp" ) {
        shippingIconText = translate("Next Day Air Only");
        shippingClassificationSVG = fields.shippingRestrictionIconSvgCodeNextDayAir;
        
    }
    else if (product.detail?.shippingClassification?.toLowerCase() === "md"){
        shippingIconText = translate("Requires Dry Ice");
        shippingClassificationSVG = fields.dryIceIconSvgCode;
        isProductDryIce = true;
    }
    else if (product.detail?.shippingClassification?.toLowerCase() === "ml"){
        shippingIconText = translate("Must Ship Freight");
        shippingClassificationSVG = fields.mustShipFreightIconSvgCode;
    }
    else if (
        product.detail?.shippingClassification?.toLowerCase() === "mg" ||
        product.detail?.shippingClassification?.toLowerCase() === "mc" ||
        product.detail?.shippingClassification?.toLowerCase() === "mb"
    ) {
        shippingIconText = translate("Cannot Ship Air");
        shippingClassificationSVG = fields.shippingRestrictionIconSvgCode;
    }else{
        isShowShippingIconText = false;
    }
  
    if(product?.properties?.californiaProp65 !== "")
    {
        iscaliforniaProp65=product?.properties?.californiaProp65?.toLowerCase();
    }

    if(product?.properties?.autoLotCategory !== "")
    {
        autoLotCategoryProduct=product?.properties?.autoLotCategory?.toLowerCase();
    }
    // const hazardousIconText = product.detail?.isHazardousGood ? translate("Hazardous") : "";
    useEffect(() => {
        if (applyIconStyle) {
            setApplyIconStyleVar(styles.hazmatContainer);
        }
    });
    const autoLotCategoryProductHeader = siteMessage("Auto_Lot_Category_Product_Label").toString();
    const autoLotCategoryProductText = siteMessage("Auto_Lot_Category_Product_Message").toString();
    const autoLotCategoryProductToolTipRef = useRef<HTMLDivElement>(null);
   
    const [isAutoLotCategoryProductToolTipOpen, setIsAutoLotCategoryProductToolTipOpen] = useState(false);
    const openAutoLotCategoryProductToolTip = () => {
        setIsAutoLotCategoryProductToolTipOpen(true);
      }
    const closeAutoLotCategoryProductToolTip = () => {
        setIsAutoLotCategoryProductToolTipOpen(false);
    }

    const dryIceToolTipRef = useRef<HTMLDivElement>(null);
    const [isDryIceToolTipOpen, setIsDryIceToolTipOpen] = useState(false);
    const [showShippingRestrictionText, setShowShippingRestrictionText] = useState(false);
    const openDryIceToolTip = () => {
        setIsDryIceToolTipOpen(true);
    }
    const closeDryIceToolTip = () => {
        setIsDryIceToolTipOpen(false);
    }

    const handleClickOutside = (event: MouseEvent) => {      
        if (autoLotCategoryProductToolTipRef.current && !autoLotCategoryProductToolTipRef.current.contains(event.target as Node)) {
            closeAutoLotCategoryProductToolTip();
        }
        if (dryIceToolTipRef.current && !dryIceToolTipRef.current.contains(event.target as Node)) {
            closeDryIceToolTip();
        }
    };

    useEffect(() => {
        if (isAutoLotCategoryProductToolTipOpen || isDryIceToolTipOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isAutoLotCategoryProductToolTipOpen, isDryIceToolTipOpen]);


    return (
        <GridContainer {...styles.container} {...applyIconStyleVar}>
            {fields.showHazardousGoodIcon && product.detail?.isHazardousGood ? (
                <GridItem
                    {...styles.hazmatGridItem}
                    {...styles.hazmatHalf}
                    {...styles.thisFont}
                    {...(!applyIconStyle ? setApplyIconStyle(true) : "")as any}
                >
                    <ReactSVG src={`data:image/svg+xml;utf8,${encodeURIComponent(fields.hazardousGoodIconSvgCode)}`} />
                    {fields.hazardousGoodIconTitle}
                    {/* <Tooltip {...styles.sizeTool} triggerComponent={<Link as="span">
                        <Typography dangerouslySetInnerHTML={{ __html: fields.hazardousGoodIconSvgCode }}></Typography>
                        {fields.hazardousGoodIconTitle}
                    </Link>} text={fields.hazardousGoodIconDescription}
                        learnMoreUrl={fields.hazardousGoodIconUrl} toolTipImage={fields.hazardousGoodIconSvgCode}
                        toolTipTitle={fields.hazardousGoodIconTitle} /> */}

                </GridItem>
            ) : (
                ""
            )}            
            {fields.showShippingRestrictionIcon && isShowShippingIconText && (
                <GridItem
                    {...styles.hazmatGridItem}
                    {...styles.hazmatHalf}
                    {...styles.thisFont}
                    {...(!applyIconStyle ? setApplyIconStyle(true) : "")as any}
                >
                    <Typography as="span" css={css`
                        position: relative;
                        display: inline-flex;
                        align-items: center;
                        gap: 0.4rem;
                    `}>
                        <ReactSVG src={`data:image/svg+xml;utf8,${encodeURIComponent(shippingClassificationSVG)}`} />
                        <span>{shippingIconText}</span>
                        {isProductDryIce && (
                            <>
                                <Typography as="span" {...styles.tooltipIcon}
                                    onClick={() => { setShowShippingRestrictionText(true); openDryIceToolTip(); }}
                                    onKeyDown={(e: any) => e.keyCode === 27 ? setShowShippingRestrictionText(false) : ''}
                                    onBlur={() => setShowShippingRestrictionText(false)}
                                >
                                    <Icon src={InfoNewIcon} />
                                </Typography>
                                {isDryIceToolTipOpen && (
                                    <div ref={dryIceToolTipRef}>
                                        <Typography as='div' {...styles.tooltip} className={`${showShippingRestrictionText ? 'active' : ''}`} >
                                            <Typography as='h5' {...styles.tooltipHeading}>Dry Ice</Typography>
                                            <Typography as='span' {...styles.tooltipContent}>{fields.dryIceIconDescription}</Typography>
                                        </Typography>
                                    </div>
                                )}
                            </>
                        )}
                    </Typography>
                </GridItem>
            )}
            {fields.showCalifPropIcon && product?.properties?.californiaProp65 !== "" && iscaliforniaProp65 ==="y" && (
                <GridItem
                    {...styles.hazmatGridItem}
                    {...styles.hazmatHalf}
                    {...styles.thisFont}
                    {...(!applyIconStyle ? setApplyIconStyle(true) : "")as any}
                    title={fields.califPropIconDescription}
                >
                    <ReactSVG src={`data:image/svg+xml;utf8,${encodeURIComponent(fields.califPropIconSvgCode)}`} />
                    {fields.califPropIconTitle}
                    {/* <Tooltip {...styles.sizeTool} triggerComponent={<Link as="span">
                        <Typography dangerouslySetInnerHTML={{ __html: fields.califPropIconSvgCode }}></Typography>
                        {fields.califPropIconTitle}
                    </Link>} text={fields.califPropIconDescription}
                        learnMoreUrl={fields.califPropIconUrl} toolTipImage={fields.califPropIconSvgCode}
                        toolTipTitle={fields.califPropIconTitle} /> */}


                </GridItem>
            )}
            {fields.showAutoLotCategoryProductIcon && autoLotCategoryProduct ==="l" && (
                <GridItem
                    {...styles.hazmatGridItem}
                    {...styles.hazmatHalf}
                    {...styles.thisFont}
                    {...(!applyIconStyle ? setApplyIconStyle(true) : "")as any}
                    title={fields.autoLotCategoryProductIconDescription}
                >
                    <ReactSVG src={`data:image/svg+xml;utf8,${encodeURIComponent(fields.autoLotCategoryProductIconSvgCode)}`} />
                    {fields.autoLotCategoryProductIconTitle}
                    
                    <Typography {...styles.autoLotProductHandlingLabel}>                        
                        <Typography as="span" {...styles.tooltipIcon}
                            onClick={() => { setShowText(true); openAutoLotCategoryProductToolTip();  }}
                            onKeyDown={(e: any) => e.keyCode === 27 ? setShowText(false) : ''}
                            onBlur={() => setShowText(false)}
                        >
                            <Icon src={InfoNewIcon} />
                        </Typography>
                        {isAutoLotCategoryProductToolTipOpen && (
                            <div ref={autoLotCategoryProductToolTipRef}>
                                <Typography as='div' {...styles.tooltip} className={`${showText ? 'active' : ''}`} >
                                    <Typography as='h5' {...styles.tooltipHeading}>{autoLotCategoryProductHeader} </Typography>
                                    <Typography as='span' {...styles.autoLotTooltipContent}>{autoLotCategoryProductText} </Typography>
                                </Typography>
                            </div>
                        )}
                    </Typography>

                </GridItem>
            )}
            {fields.showRoHsIcon && product?.properties?.roHS?.toLowerCase() === "true" && (
                <GridItem
                    {...styles.hazmatGridItem}
                    {...styles.hazmatHalf}
                    {...styles.thisFont}
                    {...(!applyIconStyle ? setApplyIconStyle(true) : "")as any}
                    title={fields.roHsIconDescription}
                >
                    <ReactSVG src={`data:image/svg+xml;utf8,${encodeURIComponent(fields.roHsIconSvgCode)}`} />
                    {fields.roHsIconTitle}
                    {/* <Tooltip {...styles.sizeTool} triggerComponent={<Link as="span">
                        <Typography dangerouslySetInnerHTML={{ __html: fields.roHsIconSvgCode }}></Typography>
                        {fields.roHsIconTitle}
                    </Link>} text={fields.roHsIconDescription}
                        learnMoreUrl={fields.roHsIconUrl} toolTipImage={fields.roHsIconSvgCode}
                        toolTipTitle={fields.roHsIconTitle} /> */}

                </GridItem>
            )
            }
        </GridContainer >
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(ComplianceIcons),
    definition: {
        displayName: "Compliance Icons",
        group: "Product Details",
        allowedContexts: [ProductDetailsPageContext],
        fieldDefinitions: [
            {
                name: fields.showHazardousGoodIcon,
                displayName: "Show Hazardous Good Icon",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "Translatable",
            },
            {
                name: fields.hazardousGoodIconTitle,
                displayName: "Hazardous Good Icon Title",
                editorTemplate: "TextField",
                defaultValue: "Hazardous",
                fieldType: "Translatable",
                isVisible: widget => widget.fields.showHazardousGoodIcon,
            },
            {
                name: fields.hazardousGoodIconUrl,
                displayName: "Hazardous Good Icon URL",
                editorTemplate: "TextField",
                defaultValue: "/contact-us",
                fieldType: "Translatable",
                isVisible: widget => widget.fields.showHazardousGoodIcon,
            },
            {
                name: fields.hazardousGoodIconSvgCode,
                displayName: "Hazardous Good Icon SVG Code",
                editorTemplate: "TextField",
                defaultValue: '<svg width="21" height="22" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path fill="#0091F2" d="m5.5 5.12 5.5 5.452-5.5 5.452L0 10.572z" /><path d="M5.5 16.12a.811.811 0 0 1-.573-.235L.292 11.29a.8.8 0 0 1 0-1.136L4.927 5.56a.816.816 0 0 1 1.146 0l4.635 4.595a.8.8 0 0 1 0 1.135l-4.635 4.595a.811.811 0 0 1-.573.235Zm0-10.024a.033.033 0 0 0-.023.01L.843 10.698a.032.032 0 0 0 0 .046l4.634 4.594a.033.033 0 0 0 .046 0l4.635-4.593a.032.032 0 0 0 0-.046L5.523 6.105a.033.033 0 0 0-.023-.01v.001Z" fill="#002554" /><path fill="#FF3105" d="M10.5.12 16 5.5l-5.5 5.38L5 5.5z" /><path d="M10.5 10.975a.817.817 0 0 1-.573-.232L5.292 6.209a.781.781 0 0 1 0-1.12L9.927.554a.824.824 0 0 1 1.146 0l4.635 4.534a.781.781 0 0 1 0 1.121l-4.635 4.534a.817.817 0 0 1-.573.232Zm0-9.892a.033.033 0 0 0-.023.01L5.843 5.625a.031.031 0 0 0 0 .045l4.634 4.534a.033.033 0 0 0 .046 0l4.635-4.534a.031.031 0 0 0 0-.044l-4.635-4.535a.033.033 0 0 0-.023-.01v.001Z" fill="#002554" /><path d="M10.5 21.12a.817.817 0 0 1-.573-.232l-4.635-4.534a.781.781 0 0 1 0-1.12l4.635-4.535a.824.824 0 0 1 1.146 0l4.635 4.534a.781.781 0 0 1 0 1.121l-4.635 4.534a.817.817 0 0 1-.573.232Zm0-9.892a.033.033 0 0 0-.023.01L5.843 15.77a.031.031 0 0 0 0 .045l4.634 4.534a.033.033 0 0 0 .046 0l4.635-4.534a.031.031 0 0 0 0-.044l-4.635-4.535a.033.033 0 0 0-.023-.009Z" fill="#002554" /><path fill="#FFE500" d="m15.5 5.12 5.5 5.452-5.5 5.452-5.5-5.452z" /><path d="M15.5 16.12a.811.811 0 0 1-.573-.235l-4.635-4.594a.8.8 0 0 1 0-1.136l4.635-4.595a.816.816 0 0 1 1.146 0l4.635 4.595a.8.8 0 0 1 0 1.135l-4.635 4.595a.811.811 0 0 1-.573.235Zm0-10.024a.033.033 0 0 0-.023.01l-4.634 4.593a.032.032 0 0 0 0 .046l4.634 4.594a.033.033 0 0 0 .046 0l4.635-4.593a.032.032 0 0 0 0-.046l-4.635-4.595a.033.033 0 0 0-.023-.01v.001Z" fill="#002554" /></g></svg>',
                fieldType: "Translatable",
                isVisible: widget => widget.fields.showHazardousGoodIcon,
            },
            {
                name: fields.hazardousGoodIconDescription,
                displayName: "Hazardous Good Icon Description",
                editorTemplate: "RichTextField",
                defaultValue: "Hazardous Good Icon Description",
                fieldType: "Translatable",
                extendedConfig: { height: 100 },
                expandedToolbarButtons: {
                    moreMisc: {},
                    code: {},
                },
                isVisible: widget => widget.fields.showHazardousGoodIcon,
            },            
            {
                name: fields.showAutoLotCategoryProductIcon,
                displayName: "Show Auto Lot Category Product Icon",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "Translatable",
            },
            {
                name: fields.autoLotCategoryProductIconTitle,
                displayName: "Auto Lot Category Product Icon Title",
                editorTemplate: "TextField",
                defaultValue: "Has Expiration Date",
                fieldType: "Translatable",
                isVisible: widget => widget.fields.showAutoLotCategoryProductIcon,
            },
            {
                name: fields.autoLotCategoryProductIconUrl,
                displayName: "Auto Lot Category Product Icon URL",
                editorTemplate: "TextField",
                defaultValue: "/contact-us",
                fieldType: "Translatable",
                isVisible: widget => widget.fields.showAutoLotCategoryProductIcon,
            },
            {
                name: fields.autoLotCategoryProductIconSvgCode,
                displayName: "Auto Lot Category Product Icon SVG Code",
                editorTemplate: "TextField",
                defaultValue: '<svg width="21" height="22" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path fill="#0091F2" d="m5.5 5.12 5.5 5.452-5.5 5.452L0 10.572z" /><path d="M5.5 16.12a.811.811 0 0 1-.573-.235L.292 11.29a.8.8 0 0 1 0-1.136L4.927 5.56a.816.816 0 0 1 1.146 0l4.635 4.595a.8.8 0 0 1 0 1.135l-4.635 4.595a.811.811 0 0 1-.573.235Zm0-10.024a.033.033 0 0 0-.023.01L.843 10.698a.032.032 0 0 0 0 .046l4.634 4.594a.033.033 0 0 0 .046 0l4.635-4.593a.032.032 0 0 0 0-.046L5.523 6.105a.033.033 0 0 0-.023-.01v.001Z" fill="#002554" /><path fill="#FF3105" d="M10.5.12 16 5.5l-5.5 5.38L5 5.5z" /><path d="M10.5 10.975a.817.817 0 0 1-.573-.232L5.292 6.209a.781.781 0 0 1 0-1.12L9.927.554a.824.824 0 0 1 1.146 0l4.635 4.534a.781.781 0 0 1 0 1.121l-4.635 4.534a.817.817 0 0 1-.573.232Zm0-9.892a.033.033 0 0 0-.023.01L5.843 5.625a.031.031 0 0 0 0 .045l4.634 4.534a.033.033 0 0 0 .046 0l4.635-4.534a.031.031 0 0 0 0-.044l-4.635-4.535a.033.033 0 0 0-.023-.01v.001Z" fill="#002554" /><path d="M10.5 21.12a.817.817 0 0 1-.573-.232l-4.635-4.534a.781.781 0 0 1 0-1.12l4.635-4.535a.824.824 0 0 1 1.146 0l4.635 4.534a.781.781 0 0 1 0 1.121l-4.635 4.534a.817.817 0 0 1-.573.232Zm0-9.892a.033.033 0 0 0-.023.01L5.843 15.77a.031.031 0 0 0 0 .045l4.634 4.534a.033.033 0 0 0 .046 0l4.635-4.534a.031.031 0 0 0 0-.044l-4.635-4.535a.033.033 0 0 0-.023-.009Z" fill="#002554" /><path fill="#FFE500" d="m15.5 5.12 5.5 5.452-5.5 5.452-5.5-5.452z" /><path d="M15.5 16.12a.811.811 0 0 1-.573-.235l-4.635-4.594a.8.8 0 0 1 0-1.136l4.635-4.595a.816.816 0 0 1 1.146 0l4.635 4.595a.8.8 0 0 1 0 1.135l-4.635 4.595a.811.811 0 0 1-.573.235Zm0-10.024a.033.033 0 0 0-.023.01l-4.634 4.593a.032.032 0 0 0 0 .046l4.634 4.594a.033.033 0 0 0 .046 0l4.635-4.593a.032.032 0 0 0 0-.046l-4.635-4.595a.033.033 0 0 0-.023-.01v.001Z" fill="#002554" /></g></svg>',
                fieldType: "Translatable",
                isVisible: widget => widget.fields.showAutoLotCategoryProductIcon,
            },
            {
                name: fields.autoLotCategoryProductIconDescription,
                displayName: "Auto Lot Category Product Icon Description",
                editorTemplate: "RichTextField",
                defaultValue: "",
                fieldType: "Translatable",
                extendedConfig: { height: 100 },
                expandedToolbarButtons: {
                    moreMisc: {},
                    code: {},
                },
                isVisible: widget => widget.fields.showAutoLotCategoryProductIcon,
            },   
            {
                name: fields.showShippingRestrictionIcon,
                displayName: "Show Shipping Restriction Icon",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "Translatable",
            },
            {
                name: fields.shippingRestrictionIconTitle,
                displayName: "Shipping Restriction Icon Title",
                editorTemplate: "TextField",
                defaultValue: "Next Day Air Only",
                fieldType: "Translatable",
                isVisible: widget => widget.fields.showShippingRestrictionIcon,
            },
            {
                name: fields.shippingRestrictionIconUrl,
                displayName: "Shipping Restriction Icon Url",
                editorTemplate: "TextField",
                defaultValue: "/contact-us",
                fieldType: "Translatable",
                isVisible: widget => widget.fields.showShippingRestrictionIcon,
            },
            {
                name: fields.shippingRestrictionIconSvgCode,
                displayName: "Shipping Restriction Icon SVg Code For Can Not Ship Air",
                editorTemplate: "TextField",
                defaultValue: '<svg width="23" height="23" xmlns="http://www.w3.org/2000/svg"><defs><filter color-interpolation-filters="auto" id="a"><feColorMatrix in="SourceGraphic" values="0 0 0 0 0.000000 0 0 0 0 0.145098 0 0 0 0 0.329412 0 0 0 1.000000 0" /></filter></defs><g fill="none" fill-rule="evenodd"><g filter="url(#a)" transform="translate(.5 .248)"><path d="M20.528 10.815 13.5 7.252v-3a3 3 0 1 0-6 0v3L.473 10.815a.75.75 0 0 0-.473.697v3.75c0 .414.336.75.75.75a.75.75 0 0 0 .218-.037L7.5 13.252v3.75l-2.587 1.29a.75.75 0 0 0-.413.675v2.535c0 .414.336.75.75.75.07.011.14.011.21 0l5.04-1.5 5.04 1.5c.07.011.14.011.21 0a.75.75 0 0 0 .75-.75v-2.535a.75.75 0 0 0-.412-.675l-2.588-1.29v-3.75l6.533 2.708a.75.75 0 0 0 .217.037.75.75 0 0 0 .75-.75v-3.75a.75.75 0 0 0-.472-.682Zm-1.028 3.3L12 11.002v6.93l3 1.5v1.073l-4.5-1.313L6 20.505v-1.073l3-1.5v-6.93l-7.5 3.113v-2.138L9 8.175V4.252a1.5 1.5 0 1 1 3 0v3.923l7.5 3.802v2.138Z" fill="#002554" /></g><path fill="#002554" d="M21.096 21.364 1.297 1.564l.707-.706 19.799 19.799z" /><path fill="#F7F9FA" d="M21.872 20.754 2.073.954 2.78.249l19.8 19.799z" /></g></svg>',
                fieldType: "Translatable",
                isVisible: widget => widget.fields.showShippingRestrictionIcon,
            },
            {
                name: fields.shippingRestrictionIconSvgCodeNextDayAir,
                displayName: "Shipping Restriction Icon SVg Code For Next Day Air",
                editorTemplate: "TextField",
                defaultValue: '<svg width="23" height="23" xmlns="http://www.w3.org/2000/svg"><defs><filter color-interpolation-filters="auto" id="a"><feColorMatrix in="SourceGraphic" values="0 0 0 0 0.000000 0 0 0 0 0.145098 0 0 0 0 0.329412 0 0 0 1.000000 0" /></filter></defs><g fill="none" fill-rule="evenodd"><g filter="url(#a)" transform="translate(.5 .248)"><path d="M20.528 10.815 13.5 7.252v-3a3 3 0 1 0-6 0v3L.473 10.815a.75.75 0 0 0-.473.697v3.75c0 .414.336.75.75.75a.75.75 0 0 0 .218-.037L7.5 13.252v3.75l-2.587 1.29a.75.75 0 0 0-.413.675v2.535c0 .414.336.75.75.75.07.011.14.011.21 0l5.04-1.5 5.04 1.5c.07.011.14.011.21 0a.75.75 0 0 0 .75-.75v-2.535a.75.75 0 0 0-.412-.675l-2.588-1.29v-3.75l6.533 2.708a.75.75 0 0 0 .217.037.75.75 0 0 0 .75-.75v-3.75a.75.75 0 0 0-.472-.682Zm-1.028 3.3L12 11.002v6.93l3 1.5v1.073l-4.5-1.313L6 20.505v-1.073l3-1.5v-6.93l-7.5 3.113v-2.138L9 8.175V4.252a1.5 1.5 0 1 1 3 0v3.923l7.5 3.802v2.138Z" fill="#002554" /></g><path fill="#002554" d="M21.096 21.364 1.297 1.564l.707-.706 19.799 19.799z" /><path fill="#F7F9FA" d="M21.872 20.754 2.073.954 2.78.249l19.8 19.799z" /></g></svg>',
                fieldType: "Translatable",
                isVisible: widget => widget.fields.showShippingRestrictionIcon,
            },
            {
                name: fields.shippingRestrictionIconDescription,
                displayName: "Shipping Restriction Icon Description",
                editorTemplate: "RichTextField",
                defaultValue: "Shipping Restriction Icon Description",
                fieldType: "Translatable",
                extendedConfig: { height: 100 },
                expandedToolbarButtons: {
                    moreMisc: {},
                    code: {},
                },
                isVisible: widget => widget.fields.showShippingRestrictionIcon,
            },
            {
                name: fields.dryIceIconSvgCode,
                displayName: "Shipping Restriction Icon SVG Code For Dry Ice",
                editorTemplate: "TextField",
                defaultValue: '<svg width="19" height="22" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 27"> <g fill="#002554" stroke="#002554" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"> <path d="M12 13.5V1M15.3 3.2 12 5.1s-1.6-.9-3.3-1.9M12 13.5V26M8.7 23.8c1.7-1 3.3-1.9 3.3-1.9l3.3 1.9M12 13.5 1 19.8M1.3 15.8l3.3 1.9v3.8M12 13.5l11-6.3M22.7 11.2c-1.7-1-3.3-1.9-3.3-1.9V5.5M12 13.5l11 6.3M19.4 21.5v-3.8s1.6-.9 3.3-1.9M12 13.5 1 7.2M4.6 5.5v3.8l-3.3 1.9" /> </g> </svg>',
                fieldType: "Translatable",
                isVisible: widget => widget.fields.showShippingRestrictionIcon,
            },
            {
                name: fields.dryIceIconDescription,
                displayName: "Dry Ice Icon Description",
                editorTemplate: "RichTextField",
                defaultValue: "Dry Ice Icon Description",
                fieldType: "Translatable",
                extendedConfig: { height: 100 },
                expandedToolbarButtons: {
                    moreMisc: {},
                    code: {},
                },
                isVisible: widget => widget.fields.showShippingRestrictionIcon,
            },
            {
                name: fields.mustShipFreightIconSvgCode,
                displayName: "Shipping Restriction Icon SVG Code For Must Ship Freight",
                editorTemplate: "TextField",
                defaultValue: '<svg width="33" height="22" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33 22"><path style="fill:#001d42;" class="st0" d="M.64 13.51c-.36 0-.61-.29-.61-.64V1.47c0-.19 0-.33.01-.41C.07.79.18.57.37.38.62.13.94 0 1.31 0h17.25c.46 0 .81.19 1.04.57.1.17.15.36.15.58v11.58c0 .08 0 .18-.01.3 0 .02 0 .03-.01.05-.08.21-.22.35-.41.41-.06.02-.25.03-.59.03H.63h.01Z"/><path style="fill:#001d42;" class="st0" d="M.39 18.01a.637.637 0 0 1-.38-.6v-2.14c0-.24.02-.42.07-.52.1-.23.31-.35.62-.35h19.27c.27 0 .46-.1.55-.29.05-.1.07-.31.07-.62V3.75c0-.29.18-.5.43-.59a.88.88 0 0 1 .26-.03h4.76c.3 0 .5.01.61.03.36.08.65.25.92.5.07.06.16.18.29.34 1.28 1.72 2.67 3.61 4.18 5.67.17.23.3.41.39.55.11.17.21.42.3.74.04.16.06.43.06.8v3.94c0 .06.05.2.16.44l.05.19v.95c0 .2-.03.34-.07.42-.07.13-.17.22-.29.29-.09.04-.22.07-.4.07h-2.29c-.14 0-.25-.02-.33-.04-.36-.14-.39-.47-.54-.78a4.41 4.41 0 0 0-1.23-1.55c-.55-.43-1.15-.69-1.79-.77-.73-.09-1.43.03-2.1.38-.78.41-1.39 1.04-1.83 1.9-.03.07-.07.15-.11.26-.11.28-.22.49-.53.58-.06.02-.18.03-.34.03h-8.82c-.26 0-.45-.09-.59-.28-.11-.15-.18-.39-.26-.55-.53-1.04-1.45-1.87-2.55-2.2-1.93-.57-3.84.56-4.57 2.4-.09.22-.15.35-.2.4-.11.11-.24.19-.38.22H.83c-.23 0-.38-.02-.47-.06h.02ZM23.6 5.1c-.25 0-.45.12-.51.38v3.34c0 .26.1.43.3.51.11.04.21.04.34.04h4.99c.29 0 .52-.22.47-.52 0-.06-.07-.17-.19-.33-.89-1.2-1.62-2.18-2.18-2.94-.18-.24-.29-.47-.62-.47h-2.6Z"/><path style="fill:#001d42;" class="st0" d="M26.86 16.3a2.958 2.958 0 0 1 1.62 3.07c-.09.74-.42 1.37-.99 1.88-.4.37-.9.6-1.48.69-.58.1-1.13.02-1.66-.24-.52-.26-.93-.64-1.23-1.17-.3-.52-.43-1.06-.41-1.61.03-.77.29-1.43.79-1.98a2.8 2.8 0 0 1 1.21-.79c.71-.23 1.47-.18 2.14.14ZM10.94 19.09c-.02.66-.28 1.33-.69 1.81a2.99 2.99 0 0 1-2.39 1.09c-.41-.01-.79-.1-1.14-.28-.75-.37-1.26-.97-1.52-1.8-.1-.31-.14-.64-.13-.99 0-.35.07-.68.19-.98.31-.81.85-1.38 1.62-1.71.36-.15.74-.22 1.15-.21a3 3 0 0 1 2.33 1.22c.38.51.61 1.18.59 1.85Z"/></svg>',
                fieldType: "Translatable",
                isVisible: widget => widget.fields.showShippingRestrictionIcon,
            },
            {
                name: fields.mustShipFreightIconDescription,
                displayName: "Must Ship Freight Icon Description",
                editorTemplate: "RichTextField",
                defaultValue: "This product must ship via freight carrier due to its size, weight, or handling requirements. Additional transit time, delivery coordination, and shipping costs may apply.",
                fieldType: "Translatable",
                extendedConfig: { height: 100 },
                expandedToolbarButtons: {
                    moreMisc: {},
                    code: {},
                },
                isVisible: widget => widget.fields.showShippingRestrictionIcon,
            },
            {
                name: fields.showCalifPropIcon,
                displayName: "Show Calif Prop Icon",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "Translatable",
            },
            {
                name: fields.califPropIconTitle,
                displayName: "Calif Prop Icon Title",
                editorTemplate: "TextField",
                defaultValue: "Calif. Prop 65",
                fieldType: "Translatable",
                isVisible: widget => widget.fields.showCalifPropIcon,
            },
            {
                name: fields.califPropIconUrl,
                displayName: "Calif Prop Icon Url",
                editorTemplate: "TextField",
                defaultValue: "/contact-us",
                fieldType: "Translatable",
                isVisible: widget => widget.fields.showCalifPropIcon,
            },
            {
                name: fields.califPropIconSvgCode,
                displayName: "Calif Prop Icon SVG code",
                editorTemplate: "TextField",
                defaultValue: '<svg width="22" height="21" xmlns="http://www.w3.org/2000/svg"><defs><filter color-interpolation-filters="auto" id="a"><feColorMatrix in="SourceGraphic" values="0 0 0 0 0.000000 0 0 0 0 0.145098 0 0 0 0 0.329412 0 0 0 1.000000 0" /></filter></defs><g transform="translate(.498 -1)" filter="url(#a)" fill="none" fill-rule="evenodd"><g fill="#002554" fill-rule="nonzero"><path d="M10.502 16.5a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25Zm-.75-8.25h1.5V15h-1.5V8.25Z" /><path d="M20.252 21.75H.752a.75.75 0 0 1-.668-1.095l9.75-18.75a.75.75 0 0 1 1.335 0l9.75 18.75a.75.75 0 0 1-.667 1.095Zm-18.263-1.5h17.025L10.502 3.877 1.989 20.25Z" /></g></g></svg>',
                fieldType: "Translatable",
                isVisible: widget => widget.fields.showCalifPropIcon,
            },
            {
                name: fields.califPropIconDescription,
                displayName: "Calif Prop Icon Description",
                editorTemplate: "RichTextField",
                defaultValue: "Calif Prop Icon Description",
                fieldType: "Translatable",
                extendedConfig: { height: 100 },
                expandedToolbarButtons: {
                    moreMisc: {},
                    code: {},
                },
                isVisible: widget => widget.fields.showCalifPropIcon,
            },
            {
                name: fields.showRoHsIcon,
                displayName: "Show RoHs Icon?",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "Translatable",
            },
            {
                name: fields.roHsIconTitle,
                displayName: "RoHs Icon Title",
                editorTemplate: "TextField",
                defaultValue: "RoHS",
                fieldType: "Translatable",
                isVisible: widget => widget.fields.showRoHsIcon,
            },
            {
                name: fields.roHsIconUrl,
                displayName: "RoHs Icon Url",
                editorTemplate: "TextField",
                defaultValue: "/contact-us",
                fieldType: "Translatable",
                isVisible: widget => widget.fields.showRoHsIcon,
            },
            {
                name: fields.roHsIconSvgCode,
                displayName: "RoHs Icon SVg code",
                editorTemplate: "TextField",
                defaultValue: '<svg width="21" height="21" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path d="M8.758 18.677c-.886-1.35-1.13-1.667-1.851-2.407-.274-.28-.936-.894-1.472-1.365C4.297 13.908 4 13.634 4 13.578c0-.098.698-.705 1.821-1.583.873-.683 1.053-.798 1.25-.798h.158l.193.445c.437 1.007 1.064 2.38 1.164 2.548.125.211.261.277.394.19.11-.07.544-.911.998-1.93a52.652 52.652 0 0 1 1.752-3.47c.643-1.14 1.514-2.483 1.977-3.048.632-.77 2.006-2.006 2.1-1.914.015.014-.32.211-.25.147.938-.855.037 1.729.398 4.58.114.902-.013.952-.37 1.252-1.205 1.012-1.71 1.54-2.587 2.703-1.563 2.072-2.52 3.594-3.415 5.427-.18.37-.361.72-.401.776-.122.167-.188.131-.424-.227Z" fill="#002554" fill-rule="nonzero" /><circle stroke="#002554" stroke-width="1.5" cx="10.5" cy="10.5" r="9.75" /></g></svg>',
                fieldType: "Translatable",
                isVisible: widget => widget.fields.showRoHsIcon,
            },
            {
                name: fields.roHsIconDescription,
                displayName: "RoHs Icon Description",
                editorTemplate: "RichTextField",
                defaultValue: "RoHs Description",
                fieldType: "Translatable",
                extendedConfig: { height: 100 },
                expandedToolbarButtons: {
                    moreMisc: {},
                    code: {},
                },
                isVisible: widget => widget.fields.showRoHsIcon,
            }
        ]
    },
};

export default widgetModule;